import 'core-js/proposals/object-values-entries';
import React from 'react';
import ReactDom from 'react-dom';
import { isPCCheck, isIframeAndMobile } from '@utils/tools';
import { RootStore, RootStoreProvider } from './model';
import { qrCodeUrl } from '../src/common/const';
import Router from './Router/Router';
import './style/index.scss';

const urlSuffix = window.location.pathname;

function replaceLocation(path) {
  if (typeof window !== 'undefined') {
    isPCCheck()
      ? window.history.replaceState(window.history.state, '', `${window.location.origin}${path}`)
      : window.location.replace(`${window.location.origin}${path}`);
  }
}
function replaceNotReload(path) {
  if (typeof window !== 'undefined') {
    window.history.replaceState(window.history.state, '', `${window.location.origin}${path}`);
  }
}

// 返回 true 表示发生了需要停止后续代码的重定向（跨端重定向或404）
function reCodeBlock(subject) {
  // 参考https://km.sankuai.com/collabpage/1583306846,需求5和需求6
  // 替换PC或移动端路径前缀
  const newPath = subject === 'web' ? urlSuffix.replace(/^\/m/, '/web') : urlSuffix.replace(/^\/web/, '/m');
  // 如果是https://zhaopin.meituan.com或https://zhaopin.meituan.com/或https://zhaopin.meituan.com/index重定向到https://zhaopin.meituan.com/{m或web}/home
  if (/^\/$/.test(urlSuffix) || /^\/index$/.test(urlSuffix)) {
    replaceLocation(`/${subject}/home`);
    // 这种情况不需要停止后续代码，让 Router 继续渲染
    return false;
  }
  // https://zhaopin.meituan.com/mobile 或 https://zhaopin.meituan.com/mobile/ 或 https://career.meituan.com/job-list 跳转 https://zhaopin.meituan.com/m/social
  if (/^.*(\/mobile|mobile\/|\/job-list)$/im.test(urlSuffix)) {
    replaceLocation(`/${subject}/social`);
    // 这种情况不需要停止后续代码，让 Router 继续渲染
    return false;
  }
  // 移动端环境,但是是/web的链接则跳转到/m的链接（跨端重定向，需要停止）
  if (subject === 'm' && /^\/web\//.test(urlSuffix)) {
    replaceLocation(`${newPath}${window.location.search}${window.location.hash}`);
    return true;
  }
  // 非/web/开头或非/m/开头的路径是不正确的路径,跳转到404页面（需要停止）
  if (!/^\/web\//.test(urlSuffix) && !/^\/m\//.test(urlSuffix)) {
    window.location.replace(`${window.location.origin}/${subject}/404`);
    return true;
  }
  // 路径已经正确，只有在需要修改时才调用 replaceNotReload
  if (urlSuffix !== newPath) {
    replaceNotReload(`${newPath}${window.location.search}${window.location.hash}`);
  }
  // 没有发生需要停止的重定向
  return false;
}

async function renderWithHotReload(RootElement) {
  // 非PC环境则跳转移动端路由，或在iframe打开且窗口大小满足移动端条件
  let shouldRedirect = false;
  if (!isPCCheck() || isIframeAndMobile()) {
    shouldRedirect = reCodeBlock('m');
  }
  if (isPCCheck()) {
    shouldRedirect = reCodeBlock('web');
  }

  // 如果发生了重定向，停止后续代码执行
  if (shouldRedirect) {
    return;
  }

  // 提前加载微信二维码需要用到的css文件，防止显示登录组件时二维码大小闪动问题
  try {
    if (window.fetch) {
      window.fetch(qrCodeUrl);
    }
  } catch (error) {
    console.error(error);
  }

  // 标识非微信环境登录
  document.cookie = 'weixinType=1; path=/; domain=meituan.com;max-age=43200;';
  ReactDom.render(
    <RootStoreProvider rootStore={RootStore}>
      <RootElement />
    </RootStoreProvider>,
    document.getElementById('app'),
  );
}

renderWithHotReload(Router);
